import BaseApp from "../BaseApp";
import Desktop from "../../classes/desktop/Desktop";


export default class DesktopApp extends BaseApp {
    onReady() {
        this.desktop = new Desktop({
            box: ".desktop"
        });
    }
}
